import axios from './axiosInstance';


const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};

const GetImages=({token,venue}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/images/`, {venue})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetCommonImages=() => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.get(`/images/common`)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetImage=({token,_id,venue }) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/images/${_id}`, {venue})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const AddImage=({token,image}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/images/add`,image)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const DeleteImage=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.delete(`/images/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UpdateImage=({token,image}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/images/update/${image._id}`,image)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

export {
    GetImages,
    GetCommonImages,
    GetImage,
    AddImage,
    DeleteImage,
    UpdateImage,
}



